export const SURPRISE_NAME_PREFIX_LABEL = 'BP Box';

/** Used only when creating a surprise pack (saved API name with trailing space). */
export const SURPRISE_NAME_PREFIX_WITH_SPACE = `${SURPRISE_NAME_PREFIX_LABEL} `;

export const getSurprisePackNameHelperText = () =>
  'Escribe solo el nombre del pack; el prefijo se agrega automáticamente. ' +
  'Debe dar una noción de qué puede contener sin especificar productos exactos. ' +
  `\nEjemplo: ${SURPRISE_NAME_PREFIX_LABEL} Merienda o ${SURPRISE_NAME_PREFIX_LABEL} Dulce`;

export const getSurprisePackDescriptionHelperText = () =>
  'Describe claramente qué tipo de opciones puede traer (sabores, categorías o combinaciones), ' +
  'sin detallar productos exactos.\nEjemplo: Selección de 3 panes distintos y panes de queso o ' +
  'Selección de distintas frutas para hacer licuados.';

/** Use with TextField helperText that contains `\n` (e.g. surprise-pack description). */
export const multilineHelperTextProps = { sx: { whiteSpace: 'pre-line' } } as const;

export const ensureSurpriseNamePrefix = (name?: string) => {
  const baseName = (name || '').trim();
  const withoutPrefix = baseName.startsWith(SURPRISE_NAME_PREFIX_LABEL)
    ? baseName.slice(SURPRISE_NAME_PREFIX_LABEL.length).trim()
    : baseName;
  return `${SURPRISE_NAME_PREFIX_LABEL} ${withoutPrefix}`;
};

export const removeSurpriseNamePrefix = (name?: string) => {
  const baseName = (name || '').trim();
  return baseName.startsWith(SURPRISE_NAME_PREFIX_LABEL) ? baseName.slice(SURPRISE_NAME_PREFIX_LABEL.length).trim() : baseName;
};
